@if (clips.length) {
  <section class="mb-6">
    <div
      class="relative flex items-center justify-center w-full aspect-[16/9] bg-gray-200">
      @if (hasAnyResources) {
        @for (clip of clips; track clip.controls.$key.value) {
          <app-video-shot-asset
            #asset
            [clip]="clip"
            [hidden]="!isActiveClip(clip)" />
        }
        @if (!active()) {
          <p-button
            icon="pi pi-refresh"
            label="Restart"
            (onClick)="onRestart()" />
        }
      } @else {
        <p-message
          icon="pi pi-exclamation-triangle"
          severity="warn"
          variant="simple">
          Nothing to preview yet...
        </p-message>
      }
    </div>
  </section>
  <section>
    <div class="flex items-center flex-wrap -m-2">
      @for (clip of clips; track clip.controls.$key.values) {
        <div class="m-2">
          <app-video-preview-clip
            [clip]="clip"
            [active]="isActiveClip(clip)"
            (clipClick)="onClipStart(clip)" />
        </div>
      }
    </div>
  </section>
} @else {
  <section>
    <div
      class="flex items-center justify-center w-full aspect-[16/9] bg-gray-200">
      <p-message
        icon="pi pi-exclamation-triangle"
        severity="warn"
        variant="simple">
        Nothing to preview yet...
      </p-message>
    </div>
  </section>
}
